import { render, staticRenderFns } from "./terms_of_service.vue?vue&type=template&id=67ed23f2"
import script from "./terms_of_service.vue?vue&type=script&lang=js"
export * from "./terms_of_service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports